import { useEffect } from 'react';

const HIDE_BELOW_Y = 140;
const MIN_DELTA = 5;

// The page may be scrolled by an ancestor rather than the document — for
// example when embedded in a preview frame — so find whichever box is
// actually scrolling.
function scrollTopOf(nav) {
  let node = nav.parentElement;
  while (node && node !== document.body) {
    const scrollable = node.scrollHeight - node.clientHeight > 40;
    if (scrollable && /auto|scroll|overlay/.test(getComputedStyle(node).overflowY)) {
      return node.scrollTop;
    }
    node = node.parentElement;
  }
  return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
}

/** Slides the sticky nav out of view while scrolling down, back in on scroll up. */
export function useNavAutoHide(navRef) {
  useEffect(() => {
    let lastY = null;

    const onScroll = () => {
      const nav = navRef.current;
      if (!nav) return;
      const y = scrollTopOf(nav);
      if (lastY === null) {
        lastY = y;
        return;
      }
      const dy = y - lastY;
      if (Math.abs(dy) < MIN_DELTA) return;
      nav.style.transform = dy > 0 && y > HIDE_BELOW_Y ? 'translateY(-110%)' : 'translateY(0)';
      lastY = y;
    };

    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      document.removeEventListener('scroll', onScroll, true);
      window.removeEventListener('scroll', onScroll);
    };
  }, [navRef]);
}
